// extracted by mini-css-extract-plugin
module.exports = {"xp-table":"Levels_xp-table__1pu_X","pagination":"Levels_pagination__1T0-N"};